import styled from 'styled-components';
export const StyledSelect = styled.select `
  border: 1px solid #cccccc;
  border-radius: 2px;
  height: 40px;
  padding: 8px;
  width: 100%;

  ${({ state }) => {
    if (state === 'error') {
        return 'border: 1px solid #f00;';
    }
    return null;
}}

  &:focus {
    border: 1px solid #355c7e;
  }

  &:focus + label {
    color: #355c7e;
  }
`;
export const Wrapper = styled.div `
  color: #000000;
  font-size: 15px;
  min-height: 70px;
  letter-spacing: 0;
  padding-top: 10px;
  position: relative;
`;
export const StyledLabel = styled.label `
  background-color: #fff;
  position: absolute;
  left: 5px;
  top: 0px;

  ${({ state }) => {
    if (state === 'error') {
        return 'color: #f00;';
    }
    return null;
}}
`;
export const StyledError = styled.div `
  color: #f00;
  font-size: 12px;
  margin: 2px 0px 0px 5px;
`;
